import React from "react";
import StyledCard from "./StyledCard";
import LottieAnimation from "../Common/Lottie";
import InvestmentAnimation from "../../Animations/investment.json";
import coinSlide from "../../Animations/coinSlide.json";
import newspaper from "../../Animations/newspaper.json";

import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";

const useStyles = makeStyles(() => ({
  root: {
    //minHeight: "90vh",
    //border: "1px solid",
  },
  btn: {
    padding: "1rem",
    border: "none",
    borderRadius: 40,
    fontWeight: "600",
    marginTop: "2rem",
    color: "white",
    backgroundImage: "linear-gradient(to right, #05ce91 , #005bff)",
    cursor: "pointer",
    maxWidth: "80vw",
    fontSize: "larger",
  },
  cardsContainer: {
    //border: "1px solid lightgray",
  },
  imageContainer: {
    //border: "1px solid lightgray",
    maxWidth: "80vw",
  },
  card: {
    padding: "2rem",
  },
}));

export default function Home({ history }) {
  const classes = useStyles();
  const handleClick = () => {
    history.push("/currencies");
  };

  return (
    <Grid container>
      <Grid item sm={2} xs={false}></Grid>
      <Grid item sm={8} xs={12}>
        <div className={"header-space"}></div>
        <Grid className={classes.root} container direction="column">
          <Grid className={classes.intro} item container>
            <Grid
              item
              sm={6}
              xs={12}
              container
              justifyContent="flex-start"
              style={{ padding: "2rem" }}
            >
              <Typography variant="h5">
                Know more about the Crypto-world before
                <span className={"light1"}> investing</span>. Get
                <span className={"light2"}> perdictions</span> of different
                crypto-currencies.
              </Typography>
              <button className={classes.btn} onClick={handleClick}>
                See Different CryptoCurrencies
              </button>
            </Grid>
            <Grid item sm={6} xs={12} className={classes.imageContainer}>
              <LottieAnimation
                lotti={InvestmentAnimation}
                height={300}
                width={300}
              />
            </Grid>
          </Grid>
          <Grid className={classes.cardsContainer} container>
            <Grid item sm={6} xs={12} className={classes.card}>
              <StyledCard
                title="CryptoCurrencies"
                subtitle="see details of all cryptocurrencies."
                path="/currencies"
                animation={coinSlide}
              />
            </Grid>
            <Grid item sm={6} xs={12} className={classes.card}>
              <StyledCard
                title="News"
                subtitle="see news."
                path="/news"
                animation={newspaper}
              />
            </Grid>
          </Grid>
        </Grid>
        <div className={"footer-space"}></div>
      </Grid>
      <Grid item sm={2} xs={false}></Grid>
    </Grid>
  );
}
